<template>
  <section
    id="contact"
    class="secondary">
    <v-container>
      <v-container>
        <v-layout
          wrap>
          <v-flex
            xs12
            sm12>
            <v-card
              style="padding:1em;"
              elevation="0"
              class="text-center transparent white--text">
              <v-card-title
                primary-title
                class="layout justify-center">
                <div class="headline font-weight-bold mb-4 text-center text-uppercase">Contactez-nous</div>
              </v-card-title>
              <v-card-text
                class="layout justify-center white--text">
                N’hésitez pas à nous contacter pour toute information :
              </v-card-text>
              <v-list class="transparent">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="white--text">
                      <a
                        href="tel:+33450649820"
                        class="white--text">
                        <v-icon class="white--text">
                          mdi-phone
                        </v-icon> 04 50 64 98 20
                      </a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="white--text">
                      <v-icon class="white--text">mdi-map-marker</v-icon> Annecy, Haute-Savoie, France
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="white--text">
                      <a
                        href="mailto:newmat.annecy@plafonds-tendus.fr"
                        class="white--text">
                        <v-icon
                          class="white--text">
                          mdi-email
                        </v-icon> newmat.annecy@plafonds-tendus.fr
                      </a>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-container>
  </section>
</template>

<script>

export default {
  metaInfo () {
    return {
      title: 'Plafond et mur tendus NEWMAT Annecy'
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
